import { Subscription } from "@/types";

import { axios } from "../axios.instance";

export type GetMySubscriptionRequest = void;
export type GetMySubscriptionResponse = Subscription;

export const getMySubscription = async (): Promise<GetMySubscriptionResponse | undefined> => {
  try {
    const { data } = await axios.get("users/me/subscription");
    return data;
  } catch (error) {}
};
